import { EventModel } from 'src_common/common/websocket2/models/EventModel';

type EventType = { template: string; tags: Record<string, string> } | EventModel;

const getOutrightTag = (event: EventType | null): string | undefined => {
    if (event === null) return undefined;

    return event instanceof EventModel ? event.getTag('outright') : event.tags['outright'];
};

export const isOutrightEventItem = (event: EventType | null): boolean => {
    return event?.template === 'outrights';
};

export const shouldShowUnderOutrightsFilter = (event: EventType | null): boolean => {
    // return isOutrightEventItem(event) && getOutrightTag(event) === 'yes';
    return isOutrightEventItem(event);
};

export const isSpecialOutrightEventItem = (event: EventType | null): boolean => {
    return isOutrightEventItem(event) && getOutrightTag(event) !== 'yes';
};

export const isValidEventItem = (event: EventType): boolean => {
    return isOutrightEventItem(event) || getOutrightTag(event) !== 'yes';
};

export const isNotOutrightsEventItem = (event: EventType): boolean => {
    return !isOutrightEventItem(event) && getOutrightTag(event) !== 'yes';
};
